import { styled, TableCell } from '@mui/material';


const TableCellRightCustom = styled(TableCell)(({ theme }) => ({
    borderRight: '1px solid black',
    textAlign: 'center'
}));


export default TableCellRightCustom;